/*
 * Weekend Redneck bundle: any 2 hats get 10% off, any 3 get 15% off plus
 * free shipping.
 * The bundle IS the Shopify cart, so every page reads /cart.js and shows the
 * same thing. Prices come from the cart itself (the automatic discount is
 * already applied there), so the numbers on the page always match checkout.
 *
 * Fires `wr:cart` on document with the cart after every load or change.
 */
(function () {
  var NEED = 3;
  var cart = null;
  var currency = (document.documentElement.getAttribute('data-currency') || 'USD');
  var money = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
  var fmt = function (cents) { return money.format((cents || 0) / 100); };

  function request(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong. Try again.');
        return data;
      });
    });
  }

  function isHat(item) {
    return (item.product_type || '').toLowerCase() === 'hats';
  }

  /* Everything the UI needs, derived from the cart */
  function state(c) {
    var hats = c.items.filter(isHat);
    var count = hats.reduce(function (n, i) { return n + i.quantity; }, 0);
    var left = Math.max(NEED - count, 0);
    var unlocked = count >= NEED;
    /* Tiers match the two automatic discounts: 2 hats 10%, 3 or more 15% */
    var pct = count >= 3 ? 15 : count === 2 ? 10 : 0;
    return {
      cart: c,
      hats: hats,
      count: count,
      unlocked: unlocked,
      left: left,
      pct: pct,
      msg: count === 0 ? 'Pick 3 hats, get 15% off plus free shipping'
        : count === 1 ? 'Add 1 more hat for 10% off'
        : count === 2 ? '10% off unlocked. Add 1 more for 15%'
        : 'Unlocked: 15% off plus free shipping',
      /* Free shipping comes with the third hat */
      moreLabel: count === 0 ? 'Add 3 hats to unlock' : 'Add ' + left + ' more to unlock',
      discountLabel: pct ? pct + '% off' : count === 0 ? 'Add 2 hats to unlock' : 'Add 1 more to unlock',
      subtotal: c.original_total_price,
      discount: c.total_discount,
      total: c.total_price
    };
  }

  function publish(c) {
    cart = c;
    var s = state(c);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = c.item_count;
      el.classList.toggle('is-empty', c.item_count === 0);
    });
    document.dispatchEvent(new CustomEvent('wr:cart', { detail: s }));
    return s;
  }

  var api = {
    fmt: fmt,
    state: function () { return cart ? state(cart) : null; },
    load: function () { return request('/cart.js').then(publish); },
    add: function (variantId, qty) {
      return request('/cart/add.js', { items: [{ id: Number(variantId), quantity: qty || 1 }] }).then(api.load);
    },
    change: function (key, qty) {
      return request('/cart/change.js', { id: key, quantity: qty }).then(publish);
    }
  };
  window.WRBundle = api;

  /* Busy state on a button while a request runs; errors show inline */
  function run(btn, job) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    /* Only swap the text, so a button's inner label element survives */
    var target = btn.querySelector('[data-add-text]') || btn;
    var label = target.textContent;
    btn.setAttribute('aria-busy', 'true');
    target.textContent = 'Adding';
    var note = btn.parentNode.querySelector('.bundle-error');
    if (note) note.remove();
    return job().catch(function (err) {
      var p = document.createElement('p');
      p.className = 'bundle-error';
      p.setAttribute('role', 'alert');
      p.textContent = err.message;
      btn.insertAdjacentElement('afterend', p);
    }).finally(function () {
      btn.removeAttribute('aria-busy');
      target.textContent = label;
      if (cart) document.dispatchEvent(new CustomEvent('wr:cart', { detail: state(cart) }));
    });
  }
  api.run = run;

  /* ---------- "Your bundle" panel ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function renderPanel(panel, s) {
    panel.classList.toggle('is-unlocked', s.unlocked);
    panel.querySelector('[data-bp-count]').textContent = s.count + (s.count === 1 ? ' hat' : ' hats');
    panel.querySelectorAll('[data-bp-progress] span').forEach(function (seg, i) {
      seg.classList.toggle('is-on', i < s.count);
    });
    panel.querySelector('[data-bp-msg]').textContent = s.msg;

    /* One row per hat (3 of the same hat show as 3 rows) */
    var list = panel.querySelector('[data-bp-lines]');
    list.innerHTML = '';
    s.hats.forEach(function (item) {
      for (var u = 0; u < item.quantity; u++) {
        var li = el('li', 'bline');
        if (item.image) {
          var img = el('img', 'bline__img');
          img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          img.alt = '';
          img.width = 56;
          img.height = 56;
          li.appendChild(img);
        }
        var text = el('div', 'bline__text');
        text.appendChild(el('span', 'bline__name', item.product_title.replace(' Foam Trucker', '')));
        if (item.variant_title) text.appendChild(el('span', 'bline__variant', item.variant_title));
        li.appendChild(text);
        var price = el('span', 'bline__price');
        if (item.final_price < item.original_price) price.appendChild(el('s', '', fmt(item.original_price)));
        price.appendChild(el('span', '', fmt(item.final_price)));
        li.appendChild(price);
        var rm = el('button', 'bline__remove');
        rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove one ' + item.product_title + ', ' + (item.variant_title || ''));
        rm.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 2l10 10M12 2L2 12"/></svg>';
        rm.addEventListener('click', (function (key, qty) {
          return function () { api.change(key, qty - 1); };
        })(item.key, item.quantity));
        li.appendChild(rm);
        list.appendChild(li);
      }
    });
    panel.querySelector('[data-bp-empty]').hidden = s.count > 0;

    panel.querySelector('[data-bp-subtotal]').textContent = fmt(s.subtotal);
    panel.querySelectorAll('[data-bp-reward]').forEach(function (row) {
      var shipping = row.getAttribute('data-bp-reward') === 'shipping';
      var on = shipping ? s.unlocked : s.pct > 0;
      row.classList.toggle('is-on', on);
      row.querySelector('[data-bp-value]').textContent = on ? (shipping ? 'FREE' : '−' + fmt(s.discount)) : '';
      row.querySelector('[data-bp-pill]').textContent = shipping ? (on ? 'Unlocked' : s.moreLabel) : s.discountLabel;
    });
    panel.querySelector('[data-bp-total]').textContent = fmt(s.total);
    var cta = panel.querySelector('[data-bp-checkout]');
    cta.textContent = s.cart.item_count ? 'Checkout · ' + fmt(s.total) : 'Checkout';
    cta.classList.toggle('is-disabled', !s.cart.item_count);
    if (!s.cart.item_count) cta.setAttribute('aria-disabled', 'true');
    else cta.removeAttribute('aria-disabled');
  }

  /* ---------- Hat cards ("Build your bundle" grids) ---------- */
  function initCard(card) {
    if (card.hasAttribute('data-wired')) return;
    card.setAttribute('data-wired', '');
    var add = card.querySelector('[data-bundle-add]');
    var img = card.querySelector('.bcard__img, .pcard__img');
    var color = card.querySelector('[data-bcard-color]');
    card.querySelectorAll('.bcard__swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        card.querySelectorAll('.bcard__swatch').forEach(function (o) {
          o.setAttribute('aria-checked', o === sw ? 'true' : 'false');
        });
        add.setAttribute('data-variant-id', sw.getAttribute('data-variant-id'));
        if (color) color.textContent = sw.getAttribute('data-color');
        if (img && sw.getAttribute('data-img')) {
          img.removeAttribute('srcset');
          img.src = sw.getAttribute('data-img');
        }
      });
    });
    if (add) {
      add.addEventListener('click', function () {
        run(add, function () { return api.add(add.getAttribute('data-variant-id'), 1); });
      });
    }
  }

  api.initCard = initCard;

  function renderCards(s) {
    var perProduct = {};
    s.hats.forEach(function (i) { perProduct[i.product_id] = (perProduct[i.product_id] || 0) + i.quantity; });
    document.querySelectorAll('[data-bundle-card]').forEach(function (card) {
      var n = perProduct[card.getAttribute('data-product-id')] || 0;
      card.classList.toggle('is-in', n > 0);
      var add = card.querySelector('[data-bundle-add]');
      var tag = card.querySelector('[data-bundle-tag]');
      /* The label never changes (a card can set its own via data-label);
         the card border and filled button show it's in */
      if (add && add.getAttribute('aria-busy') !== 'true' && !add.disabled) {
        add.textContent = add.getAttribute('data-label') || '+ Add to bundle';
      }
      if (tag) {
        tag.hidden = !n;
        tag.textContent = 'In bundle (' + n + ')';
      }
    });
  }

  /* ---------- Collection strip ---------- */
  function renderStrip(strip, s) {
    strip.classList.toggle('is-unlocked', s.unlocked);
    strip.querySelector('[data-bs-msg]').textContent = s.msg;
    var units = [];
    s.hats.forEach(function (item) {
      for (var u = 0; u < item.quantity; u++) units.push(item);
    });
    strip.querySelectorAll('.bstrip__slot').forEach(function (slot, i) {
      var item = units[i];
      slot.innerHTML = '';
      slot.classList.toggle('is-filled', !!item);
      if (item && item.image) {
        var img = el('img');
        img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        img.alt = item.product_title + (item.variant_title ? ', ' + item.variant_title : '');
        slot.appendChild(img);
      } else {
        var plus = el('span', '', '+');
        plus.setAttribute('aria-hidden', 'true');
        slot.appendChild(plus);
      }
      if (i === 2 && units.length > 3) slot.appendChild(el('span', 'bstrip__more', '+' + (units.length - 3)));
    });
    /* "View" drops on phones so the slots, savings and button share one row */
    var cartBtn = strip.querySelector('[data-bs-cart]');
    cartBtn.innerHTML = '';
    cartBtn.appendChild(el('span', 'bstrip__view', 'View'));
    cartBtn.appendChild(document.createTextNode('cart' + (s.cart.item_count ? ' \u00b7 ' + fmt(s.total) : '')));
    /* Savings: the cart's real discount, shown once there is anything in the bundle */
    var savings = strip.querySelector('[data-bs-savings]');
    if (savings) {
      savings.hidden = !s.count;
      savings.querySelector('[data-bs-savings-value]').textContent = fmt(s.discount);
    }
  }

  document.addEventListener('wr:cart', function (e) {
    document.querySelectorAll('[data-bundle-panel]').forEach(function (p) { renderPanel(p, e.detail); });
    document.querySelectorAll('[data-bundle-strip]').forEach(function (st) { renderStrip(st, e.detail); });
    renderCards(e.detail);
  });

  function init() {
    document.querySelectorAll('[data-bundle-card]').forEach(initCard);
    if (document.querySelector('[data-bundle-panel], [data-bundle-card], [data-bundle-strip]')) api.load();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Back/forward cache: re-read the cart when the page is shown again */
  window.addEventListener('pageshow', function (e) { if (e.persisted && cart) api.load(); });
})();
